module.exports = __webpack_public_path__ + "img/border_rectangle4.5708ac74.svg";